import Styles from './AddGroupCard.scss';

import Template from './AddGroupCard.hbs';
export default BaseView.extend({

    events: {
        click: 'onClickAddNewGroupButton'
    },

    /**
     * initialize
     *
     * Initializing function, which will be called on creation. It
     * will create a DOM element based on the given template.
     */
    initialize() {

        // Create the view, passing the styling with it
        this.setElement(Template({
            Styles
        }));

    },

    /**
     * onClickAddNewGroupButton
     *
     * This function will be called when the user clicks on the add a new
     * group card
     */
    onClickAddNewGroupButton() {

        // Navigate to the create page
        Backbone.history.navigate('groups/pick_course', {
            trigger: true
        });
    },

});
